// extracted by mini-css-extract-plugin
export default {"container":"Coupon_container__EBjLs"};